/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
// tslint:disable comment-format

import * as React from 'react';

// @FIXME/dg: Hard-coded ratings data.
import { IRating, ratings } from './ratings';

//=======================================================================
// Interfaces
//=======================================================================
interface IAcclaimRatingsID {
    productID: number;
    numberToShow: number;
    showDate: boolean;
    showReviewer: boolean;
    noRatingText?: string | undefined;
}

//=======================================================================
/**
 * AcclaimRatings component
 * @extends {React.PureComponent<IAcclaimRatingsID>}
 */
//=======================================================================
class AcclaimRatingsDisplay extends React.PureComponent<IAcclaimRatingsID> {
    //------------------------------------------------------
    //------------------------------------------------------
    constructor(props: IAcclaimRatingsID) {
        super(props);
    }

    //------------------------------------------------------
    //------------------------------------------------------
    public render(): JSX.Element | null {
        const { productID, numberToShow, showDate, showReviewer } = this.props;
        let ratingsList: IRating[] = ratings[productID || 0] || [];

        numberToShow && (ratingsList = ratingsList.slice(0, +numberToShow));

        // if (!ratingsList || !ratingsList.length) {
        //     const showText = noRatingText !== '' ? true : false;
        //     return showText ? <div className='acclaim-list'> {noRatingText}</div> : null;
        // }

        return (
            <div className='acclaim-list'>
                {ratingsList.map((acclaim: IRating, index) => (
                    <div key={index} className='acclaim-entry' tabIndex={0}>
                        <div className='acclaim-rating'>{acclaim.rating}</div>
                        {showReviewer ? <div className='acclaim-source'>{acclaim.source}</div> : ''}
                        {showDate ? <div className='acclaim-date'>{acclaim.date}</div> : ''}
                    </div>
                ))}
            </div>
        );
    }
}

export default AcclaimRatingsDisplay;
